/*
 * AT delivery date sync  (added 2026-10-10)
 * ------------------------------------------------------------------------------------------------
 * Makes sure line item property  _Voraussichtliche Lieferung  is correct at the moment of
 * add-to-cart, instead of depending on a 5-second timer.
 *
 * Rule (unchanged business logic):
 *   - Selected variant has a future custom.order_products_variant_tracking_date
 *       -> the custom date wins (same text the text/visual timer shows).
 *   - Otherwise
 *       -> do nothing, the delivery-timer app's own date is sent as before.
 *
 * Covers: product page form, sticky add-to-cart bar, Buy-it-now button, quick-buy drawer,
 *         and the Threekit 3D configurator (cart/add.js fetch with _bundle_id TK-...).
 *
 * The existing 5s setTimeout in at-product-text-timer / at-product-visual-timer is left in place
 * (it still hides the app's weekday text on the front end).
 *
 * Data comes from snippets/at-delivery-date-data.liquid.
 */
(function () {
  'use strict';
  if (window.ATDeliveryDate) return;

  var KEY = '_Voraussichtliche Lieferung';
  var PROP = 'properties[' + KEY + ']';
  var LOG = '[AT delivery date]';

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function getMap(productId) {
    if (!productId) return null;
    var nodes = document.querySelectorAll('script[data-at-delivery-dates][data-product-id="' + productId + '"]');
    if (!nodes.length) return null;
    try { return JSON.parse(nodes[nodes.length - 1].textContent || '{}'); }
    catch (e) { console.warn(LOG, 'bad JSON', e); return null; }
  }

  function getProductId(form) {
    var el = form.querySelector('input[name="product-id"]');
    if (el && el.value) return String(el.value);
    var m = (form.id || '').match(/(\d{6,})/);
    return m ? m[1] : null;
  }

  function getVariantId(form) {
    var els = toArray(form.elements).filter(function (e) { return e.name === 'id'; });
    var enabled = els.filter(function (e) { return !e.disabled && e.value; });
    var pick = enabled[0] || els[0];
    if (pick && pick.value) return String(pick.value);
    return new URLSearchParams(window.location.search).get('variant');
  }

  // Same text the visible timer uses: text timer wins if present (as before), else visual timer.
  function pickFormat() {
    if (document.getElementById('product-time-slot')) return 'text';
    if (document.querySelector('.product-time-slot')) return 'visual';
    return 'text';
  }

  function entryValue(entry, format) {
    if (!entry) return null;
    if (entry.epoch && entry.epoch * 1000 <= Date.now()) return null; // date passed -> app date
    return entry[format] || entry.text || null;
  }

  function customDateFor(form) {
    var map = getMap(getProductId(form));
    if (!map) return null;
    var vid = getVariantId(form);
    return vid ? entryValue(map[vid], pickFormat()) : null;
  }

  function apply(form) {
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

    var value = customDateFor(form);
    if (!value) return; // no custom date -> keep the app's value untouched

    var inputs = toArray(form.elements).filter(function (e) { return e.name === PROP; });
    if (!inputs.length) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.className = 'dlt_product_date';
      hidden.name = PROP;
      form.appendChild(hidden);
      inputs = [hidden];
    }
    // If the app also put an input in the form, overwrite it too -> exactly one value is sent.
    inputs.forEach(function (i) { i.value = value; i.disabled = false; });
  }

  function applyAll() {
    toArray(document.querySelectorAll('form[action*="/cart/add"]')).forEach(apply);
  }

  function formFromTarget(t) {
    if (!t) return null;
    if (t.form) return t.form;
    var f = t.closest ? t.closest('form') : null;
    if (f) return f;
    var host = t.closest ? t.closest('[form]') : null;
    return host ? document.getElementById(host.getAttribute('form')) : null;
  }

  // 1) Click (capture) – runs before the theme, Bold Options and Buy-it-now read the form.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest
      ? e.target.closest('button[type="submit"], input[type="submit"], .shopify-payment-button, shopify-buy-it-now-button')
      : null;
    if (t) apply(formFromTarget(t));
  }, true);

  // 2) Submit (capture) – runs before the theme's product-form handler (Enter key, sticky bar etc.).
  document.addEventListener('submit', function (e) { apply(e.target); }, true);

  // 3) Keep the hidden input in sync on load and after variant changes (no 5s wait).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
  document.addEventListener('variant:change', function () { setTimeout(applyAll, 0); });

  // 4) Threekit configurator: it adds parts with fetch(cart/add.js) and never sent a date.
  function appDateOnPage() {
    var els = document.querySelectorAll('input[name="' + PROP + '"]');
    for (var i = 0; i < els.length; i++) { if (els[i].value) return els[i].value; }
    return null;
  }

  function builderDate() {
    var bp = window.builderProduct;
    if (!bp) return null;
    var map = getMap(String(bp.productId));
    var custom = map ? entryValue(map[String(bp.primaryVariantId)], 'text') : null;
    return custom || appDateOnPage();
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (window.builderProduct && init && typeof init.body === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
          var body = JSON.parse(init.body);
          var isThreekit = body && Array.isArray(body.items) && body.items.some(function (it) {
            return it && it.properties && String(it.properties._bundle_id || '').indexOf('TK-') === 0;
          });
          if (isThreekit) {
            var date = builderDate();
            if (date) {
              body.items.forEach(function (it) {
                it.properties = it.properties || {};
                if (!it.properties[KEY]) it.properties[KEY] = date;
              });
              init = Object.assign({}, init, { body: JSON.stringify(body) });
            } else {
              console.warn(LOG, 'configurator add-to-cart: no delivery date found on page');
            }
          }
        }
      } catch (err) {
        console.warn(LOG, 'fetch hook skipped', err);
      }
      return originalFetch.call(this, input, init);
    };
  }

  window.ATDeliveryDate = { apply: apply, applyAll: applyAll, customDateFor: customDateFor, builderDate: builderDate };
})();
